import PropTypes from "prop-types"

import PartnerShape from "./PartnerShape"
import CustomerShape from "./CustomerShape"
import OrganizationShape from "./OrganizationShape"


const UserShape = PropTypes.shape({
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  customers: PropTypes.arrayOf(CustomerShape),
  givenName: PropTypes.string.isRequired,
  familyName: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  organization: OrganizationShape,
  organizations: PropTypes.arrayOf(OrganizationShape),
  sponsorProjects: PropTypes.arrayOf(PartnerShape),
})

export default UserShape
